import { SuperuserSkillsPage } from "@/features/superuser/skills/superuser-skills.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/superuser/skills/")({
  component: SuperuserSkillsPage,
});
